import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import GoogleAnalytics from './components/GoogleAnalytics';
import { ThemeProvider } from './contexts/ThemeProvider';
import { LayoutProvider } from './contexts/LayoutProvider';
import { LanguageProvider } from './contexts/LanguageProvider';
import './styles/index.css';

const AppFallback = () => (
  <div className="flex items-center justify-center min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)]">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-500"></div>
  </div>
);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <LayoutProvider>
        <LanguageProvider>
          <Suspense fallback={<AppFallback />}>
            <App />
          </Suspense>
          <GoogleAnalytics />
        </LanguageProvider>
      </LayoutProvider>
    </ThemeProvider>
  </React.StrictMode>
);
